<template>
    <div class="fixed z-10000000 w-full">
        <div
            class="fixed right-7 top-[52px] z-10000000 z-501 ml-7 md:absolute md:right-20 md:top-14"
        >
            <transition
                enter-active-class="transition duration-200 ease-out"
                enter-from-class="translate-y-1 opacity-0"
                enter-to-class="translate-y-0 opacity-100"
                leave-active-class="transition duration-150 ease-in"
                leave-from-class="translate-y-0 opacity-100"
                leave-to-class="translate-y-1 opacity-0"
            >
                <Announcements
                    v-if="announcementsOpened"
                    v-click-away="closeAnnouncements"
                ></Announcements>
            </transition>
        </div>

        <div
            class="fixed z-10000000 z-500 flex h-14 w-full items-center justify-between bg-[#161E2E] md:relative md:h-16"
            @click.self="handleCloseSideBarMobile"
        >
            <div class="flex items-center">
                <inertia-link href="/" class="hidden md:block">
                    <div class="flex items-center justify-center">
                        <IconLogo height="26" class="" />
                    </div>
                </inertia-link>
                <TeamMenu
                    class="sm:hidden"
                    :sidebar="false"
                    @closeMenuMobile="handleCloseSideBarMobile"
                />
                <SideBarMobile
                    class="overflow-y-scroll"
                    :opened="sideBarMobileOpened"
                    @close="handleCloseSideBarMobile"
                />
            </div>

            <div class="z-10000000 mr-6 hidden items-center md:flex">
                <inertia-link
                    v-if="globalProps.isAdmin && isInKiosk"
                    :href="route('home')"
                >
                    <div
                        class="mr-6 hidden text-xs font-medium text-white sm:block"
                    >
                        Go Back to App
                    </div>
                </inertia-link>

                <inertia-link
                    v-if="globalProps.isAdmin && !isInKiosk"
                    :href="route('kiosk.teams.index')"
                >
                    <div
                        class="mr-6 hidden text-xs font-medium text-white sm:block"
                    >
                        Kiosk
                    </div>
                </inertia-link>

                <div
                    v-if="globalProps.isAdmin && !isInKiosk"
                    class="h-8 w-px bg-[#364152]"
                ></div>

                <div class="ml-6 flex items-center gap-6">
                    <inertia-link
                        v-tooltip="{
                            content: t('vue.support'),
                            delay: { show: 1250, hide: 150 },
                        }"
                        href="/support"
                        class="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-[#374151] transition-colors duration-100 hover:bg-[#4B5563]"
                        :aria-label="t('vue.support')"
                        data-helper-tooltip="support"
                    >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                d="M15.7941 6.18488H15.7359C14.8712 -2.06462 3.12513 -2.05863 2.26342 6.18488H2.20524C1.27967 6.18488 0.544189 6.93585 0.544189 7.84591V11.5263C0.544189 12.4544 1.29799 13.1872 2.20524 13.1872H3.22246C4.21361 14.3288 6.13162 13.6217 6.13103 12.0925V7.27969C6.14247 5.85657 4.4067 5.09017 3.3665 6.03967C3.68032 4.46734 5.07102 3.27868 6.73425 3.27868H11.2651C12.9283 3.27868 14.319 4.46731 14.6328 6.03967C13.5923 5.08984 11.8566 5.85716 11.8683 7.27969V12.0924C11.8567 13.5108 13.5836 14.2798 14.6255 13.338C14.4586 14.1019 13.6215 15.8103 11.5481 15.8103H11.1401C10.9188 15.1528 10.2969 14.6779 9.56584 14.6779H8.43342C6.23228 14.7617 6.234 17.917 8.43342 18H9.56584C10.2969 18 10.9188 17.5249 11.1401 16.8676H11.5481C13.7293 16.8676 15.4701 15.2264 15.7238 13.1872H15.7941C16.7033 13.1872 17.4552 12.4525 17.4552 11.5262V7.84591C17.4552 6.93646 16.7202 6.18488 15.7941 6.18488ZM2.80901 12.13H2.20524C1.87192 12.13 1.60142 11.8603 1.60142 11.5262V7.84591C1.60142 7.51196 1.87192 7.24212 2.20524 7.24212H2.80901V12.13ZM3.86626 7.27969C3.8967 6.47959 5.04368 6.48019 5.07386 7.27969V12.0924C5.04341 12.8925 3.89644 12.8919 3.86626 12.0924V7.27969ZM11.2651 2.22145H6.73428C6.1797 2.22145 5.6484 2.32241 5.15753 2.50707C7.20498 0.535171 10.7947 0.535591 12.8419 2.50704C12.351 2.32242 11.8197 2.22145 11.2651 2.22145ZM14.1332 12.0924C14.1027 12.8925 12.9557 12.8919 12.9256 12.0924V7.27969C12.956 6.47959 14.103 6.48019 14.1332 7.27969V12.0924ZM9.56588 16.9427H8.43345C7.63335 16.9122 7.63391 15.7653 8.43345 15.7351H9.56588C10.366 15.7656 10.3654 16.9126 9.56588 16.9427ZM16.3979 11.5262C16.3979 11.8595 16.1281 12.13 15.7941 12.13H15.1903V7.24212H15.7941C16.1267 7.24212 16.3979 7.51129 16.3979 7.84591V11.5262Z"
                                fill="#FF421E"
                            />
                        </svg>
                    </inertia-link>

                    <a
                        v-tooltip="{
                            content: t('vue.documentation'),
                            delay: { show: 1250, hide: 150 },
                        }"
                        href="https://docs.dmarceye.com"
                        target="_blank"
                        rel="noopener"
                        class="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-[#374151] transition-colors duration-100 hover:bg-[#4B5563]"
                        :aria-label="t('vue.documentation')"
                        data-helper-tooltip="documentation"
                    >
                        <svg
                            width="11"
                            height="17"
                            viewBox="6.8 4.65 10.5 16.35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                d="M8.09 9.5a4 4 0 0 1 7.77 1.33c0 2.67-4 4-4 4"
                                stroke="#FF421E"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M11.86 19.5h.01"
                                stroke="#FF421E"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </a>

                    <OpenAnnouncementButton
                        :announcements-opened="announcementsOpened"
                        :has-unread-announcements="hasUnreadAnnouncements"
                        @toggle-announcements="toggleAnnouncements"
                    ></OpenAnnouncementButton>
                </div>

                <div class="mx-6 h-8 w-px bg-[#364152]"></div>

                <ProfileMenu class="shrink-0" />
            </div>
            <div class="mr-3 flex items-center gap-5 sm:mr-6 md:hidden">
                <OpenAnnouncementButton
                    :announcements-opened="announcementsOpened"
                    :has-unread-announcements="hasUnreadAnnouncements"
                    @toggle-announcements="toggleAnnouncements"
                ></OpenAnnouncementButton>
                <div
                    class="relative flex h-6 w-6 cursor-pointer items-center justify-center"
                    @click="handleSideBarMobile"
                >
                    <transition
                        enter-active-class="transition ease-in-out duration-800"
                        enter-from-class="transform opacity-0 scale-10"
                        enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-200 ease-in"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0"
                    >
                        <div v-if="!sideBarMobileOpened" class="absolute">
                            <svg
                                width="24"
                                height="16"
                                viewBox="0 0 24 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M0 0H24V2H0V0ZM0 7H24V9H0V7ZM16.32 14H0V16H16.32V14Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </transition>
                    <transition
                        enter-active-class="transition duration-1000 ease-in-out"
                        enter-from-class="transform rotate-180 opacity-0 scale-80"
                        enter-to-class="transform scale-100 rotate-0 opacity-100"
                        leave-active-class="transition duration-100 ease-in"
                        leave-from-class="transform opacity-100"
                        leave-to-class="transform opacity-0"
                    >
                        <div v-if="sideBarMobileOpened" class="absolute">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M10.7072 9.29299L1.41421 0L0 1.41421L9.29299 10.7072L4.60148e-05 20.0001L1.41426 21.4144L10.7072 12.1214L19.799 21.2132L21.2132 19.799L12.1214 10.7072L21.2132 1.61537L19.799 0.201156L10.7072 9.29299Z"
                                    fill="#FFC000"
                                />
                            </svg>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { usePage } from "@inertiajs/vue3";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { computed, ref } from "vue";
import route from "ziggy-js";
import { useTranslations } from "@/composables/useTranslations";

const { t } = useTranslations();

onMounted(() => {
    getHasUnreadAnnouncements();
});

const hasUnreadAnnouncements = ref(false);
const sideBarMobileOpened = ref(false);
const announcementsOpened = ref(false);

const globalProps = computed(() => usePage<IRhizomPageProps>().props);

const isAdmin = computed(() => {
    return globalProps.value.isAdmin;
});

const isInKiosk = computed(() => {
    return usePage<IRhizomPageProps>().url.startsWith("/kiosk");
});

const handleSideBarMobile = () => {
    sideBarMobileOpened.value = !sideBarMobileOpened.value;
};

const getHasUnreadAnnouncements = async () => {
    try {
        const response = await axios.get(
            route("user.has-unread-announcements.index"),
        );
        if (response.data.success) {
            hasUnreadAnnouncements.value = response.data.data;
        }
    } catch (error) {
        () => undefined;
    }
};

const toggleAnnouncements = () => {
    if (announcementsOpened.value) {
        announcementsOpened.value = false;
        getHasUnreadAnnouncements();
    } else {
        announcementsOpened.value = true;
    }
};

const closeAnnouncements = () => {
    announcementsOpened.value = false;
    getHasUnreadAnnouncements();
};

const handleCloseSideBarMobile = () => {
    sideBarMobileOpened.value = false;
};
</script>
